import dayjs from 'dayjs';

import { formatDate } from './formatDate';

export const getExpirationStatus = (expirationDate: string | null | undefined) => {
  if (!expirationDate) {
    return 'Бессрочно';
  }

  return dayjs(expirationDate).isBefore(dayjs())
    ? `Истек ${formatDate(expirationDate)}`
    : `До ${formatDate(expirationDate)}`;
};
